export default function DeterBrowserAutoFill() {
  // This is a work-around to block chrome/firefox from auto-filling password inputs
  return (
    <>
      <input
        type="text"
        style={{ width: 0, height: 0, right: 9999, position: 'absolute' }}
      />
      <input
        type="password"
        name="just to deter chrome password autocomplete"
        style={{ width: 0, height: 0, right: 9999, position: 'absolute' }}
      />
    </>
  );
}
